import { Injectable } from '@angular/core';

@Injectable()
export class SettingsService {
  pageSize: number;
  searchTerm: any = {};

  constructor() { }

  setPageSize(pageSize: number) {
    this.pageSize = pageSize;
  }

  getPageSize(): number {
    if (this.pageSize != null)
      return this.pageSize;
    else
      return 10;
  }

  setSearchTerm(branch: string, searchTerm: string): void {
    this.searchTerm[branch] = searchTerm;
  }

  getSearchTerm(branch: string): string {
    if (this.searchTerm[branch] != null) {
      return this.searchTerm[branch];
    } else {
      return '';
    }
  }

  clearSearchTerm(branch: string): void {
    this.searchTerm[branch] = '';
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/services/settings.service.ts